import {Consts} from "../pages/consts";
import {FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useState} from "react";

const IntakeTypeRadioGroup = ({onSetIntakeType}) => {
  const {t: t} = useTranslation();
  const [intakeType, setIntakeType] = useState(Consts.REGULARLY);

  const handleIntakeType = (value) => {
    setIntakeType(value);

    const intakeTypeObj = {
      intakeType: value,
      timingType: value === Consts.ON_DEMAND ? "" : Consts.DAY_TIMES,
      intakes: value === Consts.ON_DEMAND ? [] : Consts.DEFAULT_DAY_TIME_INTAKES
    }

    onSetIntakeType(intakeTypeObj);
  };

  return (
    <RadioGroup
      row
      name={ Consts.INTAKE_TIME_OPTIONS }
      value={ intakeType }
      onChange={ (e) => handleIntakeType(e.target.value) }
    >
      <FormControlLabel
        value={ Consts.REGULARLY }
        control={ <Radio/> }
        label={ <label>{ t(Consts.REGULARLY) }</label> }
      />
      <FormControlLabel
        value={ Consts.ON_DEMAND }
        control={ <Radio/> }
        label={ <label>{ t(Consts.ON_DEMAND) }</label> }
      />
    </RadioGroup>
  );
}

export default IntakeTypeRadioGroup;